/**
 * @flow
 * @format
 */

import React from 'react';
import { connect, type Connector } from 'react-redux';
import { Card, Row, Col, Button } from 'reactstrap';
import _ from 'lodash';
import cc from 'classcat';
import FaDownload from 'react-icons/lib/fa/download';

import { getSchematic } from '~/selectors/design';
import { branch, createSVGMarkup } from '~/utils';
// import debug from '~/utils/macros/debug.macro';
import { actions as designActions } from '~/actions/design';

import { type Dispatch } from 'redux';

import classes from './SchematicWrapper.scss';

type DispatchPropsType = {
  onDownloadSchematic: () => Object,
};

type EnhancedProps = {
  data: string,
};

type PropsType = DispatchPropsType & EnhancedProps;

// eslint-disable-next-line react/prefer-stateless-function
export class SchematicWrapper extends React.Component<PropsType> {
  static defaultProps = {
    data: '',
    onDownloadSchematic: _.noop,
  };
  props: PropsType; // eslint-disable-line react/sort-comp

  render() {
    return (
      <Row>
        <h4 className={cc(['col col-sm-12', classes.cardHeader])}>
          Schematic
          <Button
            className="ml-3"
            size="sm"
            onClick={this.props.onDownloadSchematic}
          >
            <FaDownload /> Save Image
          </Button>
        </h4>
        <Col>
          <Card body>
            <Row>
              <Col sm={12} className="pb-5">
                <div className="pl-5 pr-5">
                  {branch(
                    this.props.data.length > 0,
                    createSVGMarkup(
                      this.props.data,
                      'div',
                      'style="width: 100%; height: 500px"',
                    ),
                  )}
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    );
  }
}

function mapStateToProps(state: AppStateType): EnhancedProps {
  const { data }: { data: string } = getSchematic(state);
  return {
    data,
  };
}

function mapDispatchToProps(dispatch: Dispatch<*>): DispatchPropsType {
  return {
    onDownloadSchematic: () => dispatch(designActions.downloadSchematic()),
  };
}

const enhancer: Connector<{}, PropsType> = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default enhancer(SchematicWrapper);



// WEBPACK FOOTER //
// ./src/components/SchematicWrapper/SchematicWrapper.js